import { FOLDER_TO_STREAM } from "../constants";
import type { PushResult } from "../types";

// List of known ident folders that should not be treated as adverts
const IDENT_FOLDERS = ["truth-radio"];

export function isAdvert(albumFolder: string | undefined): boolean {
  if (!albumFolder) return false;
  // Not an advert if it's a music album or an ident folder
  if (albumFolder in FOLDER_TO_STREAM) return false;
  if (IDENT_FOLDERS.includes(albumFolder)) return false;
  return true;
}

export function formatDuration(seconds: number): string {
  const mins = Math.floor(seconds / 60);
  const secs = Math.floor(seconds % 60);
  return `${mins}:${secs.toString().padStart(2, "0")}`;
}

export async function pushToJukebox(albumFolder: string, trackFilename: string): Promise<PushResult> {
  try {
    const response = await fetch("/api/jukebox/push", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ albumFolder, trackFilename }),
    });
    return await response.json() as PushResult;
  } catch (e) {
    console.error("Failed to push to jukebox:", e);
    return { success: false, message: "Network error" };
  }
}
